// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, react/display-name */

// @ts-nocheck
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import _ from "lodash";
import { useControl } from "react-map-gl/mapbox";

import type { ControlPosition, IControl } from "react-map-gl/mapbox";
import LineMeasurementMode from "../../../../Lumber/OrthoViewer/DrawModes/LineMeasurementMode";
import PolygonMeasureMode from "../../../../Lumber/OrthoViewer/DrawModes/PolygonMeasureMode";
import PointMode from "../../../../Lumber/OrthoViewer/DrawModes/PointMode";
import React, { useImperativeHandle } from "react";
import { GeoJSONFeature } from "mapbox-gl";

export const MeasureModes = {
	line_measure: LineMeasurementMode,
	polygon_measure: PolygonMeasureMode,
	point: PointMode,
};

type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
	position?: ControlPosition;

	onCreate?: (evt: { features: GeoJSONFeature[] }) => void;
	onUpdate?: (evt: { features: GeoJSONFeature[]; action: string }) => void;
	onDelete?: (evt: { features: GeoJSONFeature[] }) => void;
};

export const DrawControl = React.forwardRef<MapboxDraw & IControl, DrawControlProps>((props: DrawControlProps, ref) => {
	// FIXME: Adding the '& IControl' because MapboxDraw is outdated
	const drawRef = useControl<MapboxDraw & IControl>(
		() => new MapboxDraw(props),
		({ map }) => {
			map.on("draw.create", props.onCreate);
			map.on("draw.update", props.onUpdate);
			map.on("draw.delete", props.onDelete);
		},
		({ map }) => {
			map.off("draw.create", props.onCreate);
			map.off("draw.update", props.onUpdate);
			map.off("draw.delete", props.onDelete);
		},
		{
			position: props.position,
		},
	);

	useImperativeHandle(ref, () => drawRef, [drawRef]);

	return null;
});

DrawControl.defaultProps = {
	onCreate: () => {},
	onUpdate: () => {},
	onDelete: () => {},
};

export default { DrawControl, MeasureModes };
